import {
    apiRequest,
    skcpnsList,
    skcpnsActive,
    skcpnsInactive,
    skcpnsDetail,
    skcpnsRankList,
    skcpnsSignatories
} from '../../../../../services/adapters/kepegawaian/skcpnsService'

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", skcpnsList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", skcpnsInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", skcpnsActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", skcpnsDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchRankList = async (query, cancelToken) => {
        return await apiRequest("get", skcpnsRankList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSignatories = async (query, cancelToken) => {
        return await apiRequest("get", skcpnsSignatories, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default IndexRepository
